
(function () {
  'use strict';

  var cfg = window.__wishlist;
  if (!cfg) return;
  if (window.__wishlist_cards_installed) return;
  window.__wishlist_cards_installed = true;

  var BTN = '.wishlist-btn';
  var CID = cfg.customerId;
  var LOGGED_IN = !!(cfg.loggedIn && CID);
  var API = cfg.apiBase || '/apps/bn';
  var CACHE_KEY = CID ? 'bn_wishlist_server_' + CID : null;
  var ASSETS = window.__wishlist_assets || {};

  var CACHE_MAX_AGE_MS = 7 * 24 * 3600 * 1000;
  var CACHE_TRUSTED_MS = 5 * 60 * 1000;

  var engineRequested = false;
  var pending = [];
  var checkDone = false;
  var checkScheduled = false;

  var savedHandles = {};
  var checkedIds = {};

  var localFlips = {};

  function hearts() {
    return document.querySelectorAll(BTN);
  }

  function engineLive() {
    return !!(
      window.__wishlist_delegated_click_installed ||
      (window.Wishlist && window.Wishlist._delegatedClickInstalled)
    );
  }

  function loadEngine() {
    if (engineRequested || engineLive()) return;
    engineRequested = true;

    if (ASSETS.css) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = ASSETS.css;
      link.media = 'print';
      link.onload = function () {
        link.media = 'all';
        link.onload = null;
      };
      document.head.appendChild(link);
    }
    if (ASSETS.js) {
      var script = document.createElement('script');
      script.defer = true;
      script.src = ASSETS.js;
      document.head.appendChild(script);
    }
    watchForEngine();
  }

  var watchTimer = null;
  var watchTicks = 0;

  function watchForEngine() {
    if (watchTimer) return;
    watchTimer = window.setInterval(function () {
      watchTicks++;
      if (engineLive()) {
        window.clearInterval(watchTimer);
        watchTimer = null;
        flushPending();
        return;
      }
      if (watchTicks > 200) {
        window.clearInterval(watchTimer);
        watchTimer = null;
        failPending();
      }
    }, 100);
  }

  function flushPending() {
    var queued = pending.slice();
    pending.length = 0;
    for (var i = 0; i < queued.length; i++) {
      var btn = queued[i];
      if (!btn) continue;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      delete localFlips[btn.dataset.productHandle];
      try {

        window.Wishlist._setHeartState(btn, btn.classList.contains('active'));
        window.Wishlist._syncHeartToServer(btn);
      } catch (e) {
      }
    }
  }

  function failPending() {
    var queued = pending.slice();
    pending.length = 0;
    for (var i = 0; i < queued.length; i++) {
      if (queued[i]) setHeart(queued[i], !queued[i].classList.contains('active'));
    }
    if (queued.length && window.BNToast) {
      window.BNToast.show({
        variant: 'error',
        icon: 'heart',
        title: "Couldn't update favourites",
        sub: 'Please refresh the page and try again.'
      });
    }
  }

  function setHeart(btn, active) {
    if (active) {
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      btn.setAttribute('aria-label', btn.dataset.ariaRemove || 'Remove from favourites');
    } else {
      btn.classList.remove('active');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', btn.dataset.ariaAdd || 'Add to favourites');
    }
  }

  function applyState(handles) {
    var list = hearts();
    for (var i = 0; i < list.length; i++) {
      var handle = list[i].dataset.productHandle;
      if (!handle) continue;
      if (Object.prototype.hasOwnProperty.call(localFlips, handle)) {
        setHeart(list[i], !!localFlips[handle]);
        continue;
      }
      setHeart(list[i], !!handles[handle]);
    }
    var temp = document.getElementById('wl-cache-paint');
    if (temp && temp.parentNode) temp.parentNode.removeChild(temp);
  }

  function readCache() {
    if (!CACHE_KEY) return null;
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.items || !parsed.items.length) return null;
      if (typeof parsed.ts !== 'number') return null;
      if (parsed.ts > Date.now()) return null;
      if (Date.now() - parsed.ts > CACHE_MAX_AGE_MS) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function runCheck() {
    checkDone = true;
    checkScheduled = false;

    var list = hearts();
    if (!list.length) return;
    if (!LOGGED_IN) {
      applyState({});
      return;
    }

    var ids = [];
    for (var i = 0; i < list.length; i++) {
      var id = list[i].dataset.productId;
      if (id && !checkedIds[id]) {
        checkedIds[id] = true;
        ids.push(id);
      }
    }
    if (!ids.length) {
      applyState(savedHandles);
      return;
    }

    window
      .fetch(API + '/wishlist/check', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_ids: ids,
          customer_id: CID,
          shop: cfg.shop
        })
      })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (res) {
        if (!res || !res.success || !res.wishlisted) {
          applyState(savedHandles);
          return;
        }
        var all = hearts();
        for (var j = 0; j < all.length; j++) {
          var pid = all[j].dataset.productId;
          if (!pid) continue;
          if (res.wishlisted[pid]) {
            savedHandles[all[j].dataset.productHandle] = true;
            all[j]._wlStoredVariants = res.wishlisted[pid];
          }
        }
        applyState(savedHandles);
      })
      .catch(function () {
        for (var m = 0; m < ids.length; m++) delete checkedIds[ids[m]];
      });
  }

  function scheduleCheck() {
    if (checkScheduled || checkDone) return;
    checkScheduled = true;

    var fired = false;
    var io = null;
    var timer = null;

    function fire() {
      if (fired) return;
      fired = true;
      if (io) {
        try {
          io.disconnect();
        } catch (e) {}
      }
      if (timer) window.clearTimeout(timer);
      runCheck();
    }

    if (typeof IntersectionObserver !== 'undefined') {
      try {
        io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                fire();
                return;
              }
            }
          },
          { rootMargin: '200px' }
        );
        var list = hearts();
        for (var k = 0; k < list.length; k++) {
          try {
            io.observe(list[k]);
          } catch (e) {}
        }
      } catch (e) {
        io = null;
      }
    }
    timer = window.setTimeout(fire, 2000);
  }

  function hydrate() {
    if (!hearts().length) return;

    if (!LOGGED_IN) {
      applyState({});
      return;
    }

    var cached = readCache();
    if (cached) {
      for (var i = 0; i < cached.items.length; i++) {
        var h = cached.items[i] && cached.items[i].h;
        if (h) savedHandles[h] = true;
      }
      applyState(savedHandles);
      if (Date.now() - cached.ts < CACHE_TRUSTED_MS && !cached.partial) {
        checkDone = true;
        var list = hearts();
        for (var k = 0; k < list.length; k++) {
          if (list[k].dataset.productId) checkedIds[list[k].dataset.productId] = true;
        }
        return;
      }
    }
    scheduleCheck();
  }

  document.addEventListener(
    'click',
    function (e) {
      if (engineLive()) return;

      var target = e.target;
      if (!target || !target.closest) return;
      var btn = target.closest(BTN);
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (!LOGGED_IN) {
        if (window.BNAccount && window.BNAccount.open('Sign in to add to favourites')) return;
        loadEngine();
        return;
      }

      var willActive = !btn.classList.contains('active');
      localFlips[btn.dataset.productHandle] = willActive;
      setHeart(btn, willActive);

      if (window.BNHeartSound) {
        try { willActive ? window.BNHeartSound.add() : window.BNHeartSound.remove(); } catch (e) {   }
      }

      window.__wishlist_local_flips = window.__wishlist_local_flips || {};
      window.__wishlist_local_flips[btn.dataset.productHandle] = Date.now();

      btn._wlData = {
        h: btn.dataset.productHandle,
        pid: btn.dataset.productId || '',
        vid: btn.dataset.variantId || null,
        title: btn.dataset.productTitle || '',
        image: btn.dataset.productImage || '',
        price: btn.dataset.productPrice || '0',
        url: btn.dataset.productUrl || '',
        sku: ''
      };

      btn.classList.remove('just-clicked');
      void btn.offsetWidth;
      btn.classList.add('just-clicked');
      if (btn._wlCardPopTimer) window.clearTimeout(btn._wlCardPopTimer);
      btn._wlCardPopTimer = window.setTimeout(function () {
        btn.classList.remove('just-clicked');
        btn._wlCardPopTimer = null;
      }, 600);

      if (pending.indexOf(btn) === -1) pending.push(btn);
      loadEngine();
      watchForEngine();
    },
    true
  );

  function warm() {
    document.removeEventListener('pointerover', onHoverIntent);
    document.removeEventListener('touchstart', onTouchIntent, true);
    loadEngine();
  }

  function onHoverIntent(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.closest('product-card')) return;
    warm();
  }

  function onTouchIntent(e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (!target.closest(BTN)) return;
    warm();
  }

  if (LOGGED_IN) {
    document.addEventListener('pointerover', onHoverIntent);
    document.addEventListener('touchstart', onTouchIntent, true);
  }

  var repaintTimer = null;

  function installObserver() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      for (var i = 0; i < mutations.length && !found; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches(BTN)) || (node.querySelector && node.querySelector(BTN))) {
            found = true;
            break;
          }
        }
      }
      if (!found) return;
      if (repaintTimer) window.clearTimeout(repaintTimer);
      repaintTimer = window.setTimeout(function () {
        repaintTimer = null;
        if (engineLive()) return;
        if (!checkDone) {
          scheduleCheck();
          return;
        }
        applyState(savedHandles);
        if (LOGGED_IN) runCheck();
      }, 80);
    });
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function boot() {
    hydrate();
    installObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
